"use client";

import React from "react";
import Footer from "../../../components/common/Footer";
import Header from "../../../components/common/Header";
import { PrivacyPolicyCommon } from "../../../components/common/PrivacyPolicy/PrivacyPolicyCommon";
import { useTranslations, useLocale } from "next-intl";
import { useTenantBranding } from "@/app/context/TenantBrandingContext";
import type { LocalizedText } from "@/app/api/utils/types/tenants";
import sanitizeHtml from "sanitize-html";

function getLocalizedText(text: LocalizedText | undefined, locale: string): string {
  if (!text) return "";
  return text[locale as keyof LocalizedText] || text.en || "";
}

export default function PrivacyPolicyPage() {
  const t = useTranslations();
  const locale = useLocale();
  const { policies } = useTenantBranding();

  const tenantContent = getLocalizedText(policies?.privacyPolicy, locale);

  return (
    <div className="flex min-h-screen flex-col bg-white dark:bg-sleap-gray-950">
      <Header />

      <main className="flex-grow py-4 sm:py-4 md:py-16 lg:pt-6 lg:pb-24">
        <div className="mx-auto max-w-6xl px-4 sm:px-4 md:px-6">
          <div className="self-stretch p-4 inline-flex flex-col justify-start items-start gap-6">
            <div className="self-stretch justify-start text-zinc-900 text-3xl font-bold font-switzer leading-loose dark:text-white sm:text-2xl lg:text-4xl">
              {t("Other.privacyPolicy")}
            </div>
            {tenantContent ? (
              <div
                className="prose prose-zinc dark:prose-invert max-w-none w-full font-switzer text-base leading-relaxed"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(tenantContent) }}
              />
            ) : (
              <PrivacyPolicyCommon />
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
